import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Caution as CautionIcon } from "@air/next-icons";
import { DELETE_ASSETS_WARNING } from "~/constants/testIDs";
export const DeleteAssetsWarning = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-start",
        "data-testid": DELETE_ASSETS_WARNING,
        children: [
            /*#__PURE__*/ _jsx(CautionIcon, {
                className: "size-6 text-flamingo-300"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ml-2 text-14 text-flamingo-700",
                children: [
                    "Deleted assets ",
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-14 font-semibold text-inherit",
                        children: "cannot be recovered"
                    })
                ]
            })
        ]
    });
};
